module.exports = __webpack_public_path__ + "media/packs/images/flags/CW-c7b13308329ba40ad784418d0ba37bec.svg";